"use client";
/*
 * Documentation:
 * DC_Media_Image — https://app.subframe.com/4f62853ee923/library?component=DC_Media_Image_7f737704-99dd-4bd5-b329-9a420525b56f
 */

import React from "react";
import * as SubframeUtils from "../utils";

interface Dc_Media_ImageRootProps extends React.HTMLAttributes<HTMLDivElement> {
  noContainer?: boolean;
  image?: string;
  children?: React.ReactNode;
  className?: string;
}

const Dc_Media_ImageRoot = React.forwardRef<
  HTMLDivElement,
  Dc_Media_ImageRootProps
>(function Dc_Media_ImageRoot(
  {
    noContainer = false,
    image,
    children,
    className,
    ...otherProps
  }: Dc_Media_ImageRootProps,
  ref
) {
  return (
    <div
      className={SubframeUtils.twClassNames(
        "group/7f737704 flex w-full flex-col items-start rounded-md bg-neutral-50 px-4 py-4",
        { "flex-col flex-nowrap gap-4 bg-transparent px-0 py-0": noContainer },
        className
      )}
      ref={ref}
      {...otherProps}
    >
      {children ? (
        <div className="flex w-full flex-col items-start">{children}</div>
      ) : null}
    </div>
  );
});

export const Dc_Media_Image = Dc_Media_ImageRoot;
